import { URLSearchParams, BaseRequestOptions } from '@angular/http';

export const createRequestOption = (req?: any): BaseRequestOptions => {
    const options: BaseRequestOptions = new BaseRequestOptions();
    if (req) {
        const params: URLSearchParams = new URLSearchParams();
        params.set('skip', ((req.page) * req.size).toString());
        params.set('take', req.size);

        if (req.sort && req.sort[0] && req.sort[0].split(',').length) {
            params.set('orderBy', req.sort[0].split(',')[0]);
            params.set('orderType', req.sort[0].split(',')[1]);
        }

        // For each search Params and set to Params
        if (req.searchParams && req.searchParams !== {}) {
            for (const searchKey of Object.keys(req.searchParams)) {
                if (req.searchParams[searchKey] !== null) {
                    params.set(searchKey, req.searchParams[searchKey]);
                }
            }
        }

        options.params = params;
    }

    return options;
};
